<div class="container_tab_nav">
  <ul class="nav nav-tabs two" role="tablist" aria-label="Gestione fascicoli">
    <li role="presentation" [style.width.%]="50">
      <button
        role="tab"
        type="button"
        id="tab-0-protocol"
        class="btn-link"
        [attr.aria-selected]="activeTab === 0"
        [attr.aria-controls]="'tabpanel-0'"
        [class.active]="activeTab === 0"
        [class.inactive]="activeTab !== 0"
        (click)="setActiveTab(0)"
      >
        Cerca su E-Grammata
      </button>
    </li>

    <li role="presentation" [style.width.%]="50">
      <button
        role="tab"
        type="button"
        id="tab-1-protocol"
        class="btn-link"
        [attr.aria-selected]="activeTab === 1"
        [attr.aria-controls]="'tabpanel-1'"
        [class.active]="activeTab === 1"
        [class.inactive]="activeTab !== 1"
        (click)="setActiveTab(1)"
      >
        Inserisci Nuovo
      </button>
    </li>
  </ul>

  <div class="tab-content">
    <div
      role="tabpanel"
      id="tabpanel-0"
      [attr.aria-labelledby]="'tab-0-protocol'"
      [hidden]="activeTab !== 0"
      [ngClass]="{'active in': activeTab === 0}"
    >
      <app-protocol-fascicolo-search
        [fascicolo]="fascicolo"
        (onImport)="doImport($event)"
        [idPratica]="praticaId"
      ></app-protocol-fascicolo-search>
    </div>

    <div
      role="tabpanel"
      id="tabpanel-1"
      [attr.aria-labelledby]="'tab-1-protocol'"
      [hidden]="activeTab !== 1"
      [ngClass]="{'active in': activeTab === 1}"
    >
      <app-protocol-fascicolo-insert
        (onInsert)="doInsert($event)"
        [idPratica]="praticaId"
      ></app-protocol-fascicolo-insert>
    </div>
  </div>
</div>
